import React from "react";

import { TONE } from "../constants";
import Chip from "./Chip";

const HEALTH_TONE = {
    healthy: TONE.emerald,
    unreachable: TONE.rose,
    degraded: TONE.rose,
};

// The result of the last health check on one database. "unknown" is its own
// state: no check has run, which is not the same as a check that failed.
const HealthBadge = ({ health }) => (
    <Chip
        tone={HEALTH_TONE[health] ?? TONE.slate}
        label={health || "unknown"}
        title={
            health === "healthy"
                ? "The last health check on this database succeeded."
                : health === "unreachable" || health === "degraded"
                ? "The last health check on this database failed."
                : "No health check has run against this database yet."
        }
    />
);

export default HealthBadge;
